import { serviceProvider } from '@yola/subscription-manager-js';
import { errors } from '@yola/ws-sdk';
import fetchCurrentPackageComplete from '../actions/fetch-current-package-complete';

const fetchCurrentPackage = () => async (dispatch) => {
  try {
    await serviceProvider.fetchCurrentPackage();
    dispatch(fetchCurrentPackageComplete());
  } catch (error) {
    errors.operations.catchError(error);
  }
};

export default fetchCurrentPackage;
